import { render } from "./HomeClient.vue?vue&type=template&id=2a48d97a&scoped=true"
import script from "./HomeClient.vue?vue&type=script&lang=js"
export * from "./HomeClient.vue?vue&type=script&lang=js"

import "./HomeClient.vue?vue&type=style&index=0&id=2a48d97a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a48d97a"]])

export default __exports__